import { gql } from '@apollo/client';
const AUTOCOMPLETE_ATTRIBUTE_VARIANT = gql `
  query AutocompleteAttributeVariant($attributeVariantName: String!, $productId: ID!) {
    autocomplete {
      autocompleteAttributeVariant(
        attributeVariantName: $attributeVariantName
        productId: $productId
      ) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;
export default AUTOCOMPLETE_ATTRIBUTE_VARIANT;
